import React from 'react'
import { Select } from "antd"

const { Option } = Select

const FilterMaterials = (props) => {
    const { materials, onChangeMaterials, listOptions = [] } = props
    const newListOptions = !!listOptions.length ? listOptions.reduce((unique, obj) => {
        if (!unique.some(item => item.id === obj.id && item.name === obj.name)) {
            unique.push(obj)
        }
        return unique
    }, []).map(i => {
        const { partner = {} } = i
        const { hidden = false } = partner
        if (hidden === false) return i
    }).filter(Boolean) : []

    const _handleChange = (value) => {
        if (typeof onChangeMaterials === 'function') {
            onChangeMaterials(value)
        }
    }

    return (
        <div className='FilterMaterials'>
            <Select
                mode="multiple"
                style={{ width: '100%' }}
                showArrow={true}
                placeholder="Vui lòng chọn nguyên vật liệu"
                defaultValue={materials}
                onChange={_handleChange}
                value={materials}
                allowClear
                showSearch
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
                {!!newListOptions && newListOptions.length > 0 &&
                    newListOptions.map((option) => {
                        return <Option key={option._id} value={option.name}>{`${option.code} - ${option.name}`}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default FilterMaterials